import { NotFoundState } from '@kanos/web-core';
import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  Outlet,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { LeaveGuard } from '../leave-guard';
import { SessionGate } from '../session-gate';
import { AppShell } from '../shell';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <SessionGate>
      <AppShell>
        <FocusOnNavigation />
        <LeaveGuard />
        <Outlet />
      </AppShell>
    </SessionGate>
  ),
  notFoundComponent: NotFound,
});

function NotFound() {
  const navigate = useNavigate();
  return <NotFoundState onHome={() => void navigate({ to: '/' })} />;
}

/**
 * After a change of page, focus moves to the main content: a screen reader starts reading the
 * new page there, and the keyboard does not start again at the header. Not on the first load.
 */
function FocusOnNavigation() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    document.getElementById('main-content')?.focus({ preventScroll: true });
  }, [pathname]);
  return null;
}
